<style scoped>

</style>

<template>
    <span>
        <span class="spinner-border spinner-border-sm"></span>
        <span class="visually-hidden" role="status">Saugoma...</span>
    </span>
</template>

<script>
    export default {
        name: 'spinner'
    }
</script>